// Action Tools
export const ACTION_TOOL_ADD_ACTION_BUTTON = "addActionButton"

// Cite Tools
export const CITE_TOOL_ADD_SOURCE = "addSource"

// Visitor Email Tools
export const VISITOR_EMAIL_TOOL_REQUEST = "requestVisitorEmail"

// Changelog Tools
export const CHANGELOG_TOOL_GET_ENTRY = "getChangelogEntry"
export const CHANGELOG_TOOL_LIST = "listChangelogs"
export const CHANGELOG_TOOL_SEARCH = "searchChangelog"

// Docs Tools
export const DOCS_TOOL_GET_INFORMATION = "getDocsInformation"
export const DOCS_TOOL_PROPOSE_UPDATE = "proposeDocsUpdate"
export const DOCS_TOOL_FETCH_LINK = "fetchDocLink"
// Anthropic's server-side fetcher. The name is fixed by the provider.
export const DOCS_TOOL_WEB_FETCH = "web_fetch"
export const DOCS_TOOL_SHOW_IMAGE = "showDocsImage"

// Connector Router Tools
export const CONNECTOR_TOOL_SEARCH = "searchConnectorTools"
export const CONNECTOR_TOOL_CALL = "callConnectorTool"

// Continue in Claude Tools
export const CONTINUE_IN_CLAUDE_TOOL_PROPOSE = "proposeContinueInClaude"

// Agent to-do list
export const AGENT_TODO_TOOL_SHOW = "showAgentTodos"

// GitHub Tools
export const GITHUB_TOOL_FETCH_PR = "fetchPullRequest"
export const GITHUB_TOOL_SEARCH_PRS = "searchPullRequests"
export const GITHUB_TOOL_SEARCH_CODE = "searchCode"
export const GITHUB_TOOL_FETCH_FILE = "fetchFile"
export const GITHUB_TOOL_LIST_COMMITS = "listCommits"
export const GITHUB_TOOL_FETCH_COMMIT = "fetchCommit"

// Linear Tools
export const LINEAR_TOOL_CREATE_ISSUE = "createLinearIssue"
export const LINEAR_TOOL_EDIT_ISSUE = "editLinearIssue"
export const LINEAR_TOOL_REMOVE_ISSUE = "removeLinearIssue"
export const LINEAR_TOOL_LIST_SESSION_ISSUES = "listSessionIssues"
export const LINEAR_TOOL_MARK_ISSUE_IMPORTANCE = "markIssueImportance"
export const LINEAR_TOOL_LINK_EXISTING_ISSUE = "linkExistingIssue"

// Macro Tools
export const MACRO_TOOL_LIST = "listMacros"
export const MACRO_TOOL_GET = "getMacro"

// Thread Tools
export const THREAD_TOOL_GET_THREAD_CONTEXT = "getThreadContext"
export const THREAD_TOOL_WRITE_TO_COMPOSER = "writeToComposer"
export const THREAD_TOOL_SEARCH_RESOLVED_THREADS = "searchResolvedThreads"
export const THREAD_TOOL_GET_RESOLVED_THREAD_MESSAGES =
	"getResolvedThreadMessages"
export const THREAD_TOOL_LIST_CUSTOMER_THREADS = "listCustomerThreads"
export const THREAD_TOOL_GET_HANDOFF_DETAILS = "getHandoffDetails"

// Customer-facing request history (widget, live chat, email/Slack/Teams agents)
export const REQUESTS_TOOL_LIST_MY_REQUESTS = "listMyRequests"

// Editor rewrite tools (docs article + changelog copilots)
export const ARTICLE_TOOL_WRITE = "writeToArticle"
export const CHANGELOG_TOOL_WRITE = "writeToChangelog"

// Workspace tools (thread-less copilot)
export const WORKSPACE_TOOL_LIST_OPEN_THREADS = "listOpenThreads"

// Reporting tools (agent-performance copilot on the reporting AI tab)
export const REPORTING_TOOL_AGENT_PERFORMANCE = "getAgentPerformance"
export const REPORTING_TOOL_LIST_ESCALATIONS = "listEscalatedConversations"
export const REPORTING_TOOL_AGENT_SETUP = "getAgentKnowledgeSetup"
export const REPORTING_TOOL_GET_ESCALATION = "getEscalatedConversation"

// Agent page tools (copilot beside a recommendation)
export const AGENT_REC_TOOL_GET = "getAgentRecommendation"
export const AGENT_REC_TOOL_UPDATE = "updateAgentRecommendation"
export const AGENT_REC_TOOL_UPDATE_DOCS = "updateRecommendationDocsChange"

// Agent setup tools (copilot as setup guide and escalation reviewer)
export const AGENT_SETUP_TOOL_GET_WORKSPACE_SETUP = "getWorkspaceSetup"
export const AGENT_SETUP_TOOL_GET_INSTRUCTIONS = "getAgentInstructions"
export const AGENT_SETUP_TOOL_PROPOSE_INSTRUCTIONS = "proposeAgentInstructions"
export const AGENT_SETUP_TOOL_PROPOSE_LINEAR_ISSUE = "proposeLinearIssue"

// Roadmap Tools
export const ROADMAP_TOOL_GET_PROJECT_DETAILS = "getRoadmapProjectDetails"
export const ROADMAP_TOOL_LIST_PROJECTS = "listRoadmapProjects"
export const ROADMAP_TOOL_LIST_ISSUES = "listRoadmapIssues"
export const ROADMAP_TOOL_LIST_PROJECT_ISSUES = "listRoadmapProjectIssues"
export const ROADMAP_TOOL_SEARCH_PROJECTS = "searchRoadmapProjects"

// Resolution Tools
export const RESOLUTION_TOOL_SET_CONFIDENCE = "setResolutionConfidence"
export const RESOLUTION_TOOL_MARK_RESOLVED = "markThreadResolved"
export const RESOLUTION_BOOKKEEPING_TOOLS: readonly string[] = [
	RESOLUTION_TOOL_SET_CONFIDENCE,
	RESOLUTION_TOOL_MARK_RESOLVED,
]
// Tools that only record something and return a constant, so the agent has
// nothing to read back from them.
export const RECORD_ONLY_AGENT_TOOLS: readonly string[] = [
	ACTION_TOOL_ADD_ACTION_BUTTON,
	CITE_TOOL_ADD_SOURCE,
	VISITOR_EMAIL_TOOL_REQUEST,
	...RESOLUTION_BOOKKEEPING_TOOLS,
]

// Silence Tool
export const SKIP_REPLY_TOOL = "skipReply"

// Stripe Tools
export const STRIPE_TOOL_GET_SUBSCRIPTION = "getStripeSubscription"
export const STRIPE_TOOL_LIST_PROMOTION_CODES = "listStripePromotionCodes"
export const STRIPE_TOOL_PROPOSE_APPLY_PROMOTION_CODE =
	"proposeApplyPromotionCode"
export const STRIPE_TOOL_PROPOSE_REMOVE_PROMOTION_CODE =
	"proposeRemovePromotionCode"
export const STRIPE_TOOL_PROPOSE_CANCEL_SUBSCRIPTION =
	"proposeCancelSubscription"
export const STRIPE_TOOL_PROPOSE_CHANGE_PLAN = "proposeChangePlan"
export const STRIPE_TOOL_PROPOSE_EXTEND_TRIAL = "proposeExtendTrial"

// Postgres Tools
export const POSTGRES_TOOL_GET_SCHEMA = "getPostgresSchema"
export const POSTGRES_TOOL_LIST_WHITELISTED_QUERIES =
	"listPostgresWhitelistedQueries"
export const POSTGRES_TOOL_RUN_WHITELISTED_QUERY = "runPostgresWhitelistedQuery"
export const POSTGRES_TOOL_PROPOSE_QUERY = "proposePostgresQuery"

// Used to display the tool in the UI
export const CHANGELOG_GENERATION_STATUSES = {
	CONNECTING: "Connecting to Linear workspace",
	FETCHING_ISSUES: "Fetching completed issues and shipped code",
	FETCHING_PROJECTS: "Fetching completed Linear projects",
	PROCESSING_DATA: "Processing and organizing the data",
	FETCHING: "Getting completed issues, projects, and shipped code",
	ANALYZING: "Analyzing your completed work",
	GENERATING: "Writing a changelog entry",
	FORMATTING: "Formatting the changelog properly",
	INSERTING: "Inserting into your editor",
	CATEGORIZING: "Categorizing issues by type and priority",
	SUMMARIZING: "Creating summaries for each change",
	OPTIMIZING: "Optimizing content structure and flow",
	FINALIZING: "Finalizing and saving your changelog",
} as const

// Map database ChangelogStatus enum to user-friendly messages
export const CHANGELOG_STATUS_MESSAGES = {
	QUEUED: "Changelog generation has started",
	FETCHING_PROJECTS: "Fetching completed Linear projects",
	FETCHING_ISSUES: "Fetching completed issues and shipped code",
	GENERATING: "Writing a changelog entry",
	UPDATING: "Inserting into your editor",
	COMPLETED: "Completed",
	FAILED: "Generation failed",
} as const

export const TOOL_NAME_MAPPINGS: Record<string, string> = {
	[ACTION_TOOL_ADD_ACTION_BUTTON]: "Adding Action Button",
	[CITE_TOOL_ADD_SOURCE]: "Adding Source Citation",
	[CHANGELOG_TOOL_SEARCH]: "Searching Changelog",
	[CHANGELOG_TOOL_GET_ENTRY]: "Reading Changelog Entry",
	[CHANGELOG_TOOL_LIST]: "Reading Changelog",
	[DOCS_TOOL_GET_INFORMATION]: "Searching Documentation",
	[DOCS_TOOL_PROPOSE_UPDATE]: "Preparing documentation proposal",
	[DOCS_TOOL_FETCH_LINK]: "Reading linked page",
	[DOCS_TOOL_SHOW_IMAGE]: "Preparing a screenshot",
	[CONTINUE_IN_CLAUDE_TOOL_PROPOSE]: "Preparing Claude handoff",
	[AGENT_TODO_TOOL_SHOW]: "Gathering your to-dos",
	[CONNECTOR_TOOL_SEARCH]: "Searching connected systems",
	[CONNECTOR_TOOL_CALL]: "Using a connected system",
	[GITHUB_TOOL_FETCH_PR]: "Reading pull request",
	[GITHUB_TOOL_SEARCH_PRS]: "Searching pull requests",
	[GITHUB_TOOL_SEARCH_CODE]: "Searching code",
	[GITHUB_TOOL_FETCH_FILE]: "Reading file",
	[GITHUB_TOOL_LIST_COMMITS]: "Listing commits",
	[GITHUB_TOOL_FETCH_COMMIT]: "Reading commit",
	[ROADMAP_TOOL_SEARCH_PROJECTS]: "Searching Roadmap Projects",
	[ROADMAP_TOOL_GET_PROJECT_DETAILS]: "Reading Roadmap Project",
	[ROADMAP_TOOL_LIST_PROJECTS]: "Reading Roadmap Projects",
	[ROADMAP_TOOL_LIST_ISSUES]: "Reading Roadmap Issues",
	[ROADMAP_TOOL_LIST_PROJECT_ISSUES]: "Reading Project Issues",
	[LINEAR_TOOL_CREATE_ISSUE]: "Creating request",
	[LINEAR_TOOL_EDIT_ISSUE]: "Editing request",
	[LINEAR_TOOL_REMOVE_ISSUE]: "Removing request",
	[LINEAR_TOOL_LIST_SESSION_ISSUES]: "Looking up issues",
	[LINEAR_TOOL_MARK_ISSUE_IMPORTANCE]: "Updating importance",
	[LINEAR_TOOL_LINK_EXISTING_ISSUE]: "Linking to existing issue",
	[THREAD_TOOL_GET_THREAD_CONTEXT]: "Reading thread context",
	[THREAD_TOOL_WRITE_TO_COMPOSER]: "Writing to editor",
	[THREAD_TOOL_SEARCH_RESOLVED_THREADS]: "Searching past threads",
	[THREAD_TOOL_GET_RESOLVED_THREAD_MESSAGES]: "Reading thread messages",
	[THREAD_TOOL_LIST_CUSTOMER_THREADS]: "Reading customer history",
	[THREAD_TOOL_GET_HANDOFF_DETAILS]: "Reading the handoff",
	[REQUESTS_TOOL_LIST_MY_REQUESTS]: "Checking your requests",
	[ARTICLE_TOOL_WRITE]: "Drafting article changes",
	[CHANGELOG_TOOL_WRITE]: "Drafting changelog changes",
	[WORKSPACE_TOOL_LIST_OPEN_THREADS]: "Reading your inbox",
	[REPORTING_TOOL_AGENT_PERFORMANCE]: "Reading agent performance",
	[REPORTING_TOOL_LIST_ESCALATIONS]: "Reading escalated conversations",
	[REPORTING_TOOL_AGENT_SETUP]: "Checking what the agent can reach",
	[REPORTING_TOOL_GET_ESCALATION]: "Reading the conversation",
	[AGENT_REC_TOOL_GET]: "Reading the suggestion",
	[AGENT_REC_TOOL_UPDATE]: "Updating the suggestion",
	[AGENT_REC_TOOL_UPDATE_DOCS]: "Rewriting the docs change",
	[AGENT_SETUP_TOOL_GET_WORKSPACE_SETUP]: "Checking your setup",
	[AGENT_SETUP_TOOL_GET_INSTRUCTIONS]: "Reading agent instructions",
	[AGENT_SETUP_TOOL_PROPOSE_INSTRUCTIONS]: "Drafting agent instructions",
	[AGENT_SETUP_TOOL_PROPOSE_LINEAR_ISSUE]: "Drafting a Linear issue",
	[STRIPE_TOOL_GET_SUBSCRIPTION]: "Reading Stripe subscription",
	[STRIPE_TOOL_LIST_PROMOTION_CODES]: "Listing promotion codes",
	[STRIPE_TOOL_PROPOSE_APPLY_PROMOTION_CODE]: "Preparing promotion code",
	[STRIPE_TOOL_PROPOSE_REMOVE_PROMOTION_CODE]: "Preparing discount removal",
	[STRIPE_TOOL_PROPOSE_CANCEL_SUBSCRIPTION]: "Preparing cancellation",
	[STRIPE_TOOL_PROPOSE_CHANGE_PLAN]: "Preparing plan change",
	[STRIPE_TOOL_PROPOSE_EXTEND_TRIAL]: "Preparing trial extension",
	[POSTGRES_TOOL_GET_SCHEMA]: "Reading database schema",
	[POSTGRES_TOOL_LIST_WHITELISTED_QUERIES]: "Listing saved queries",
	[POSTGRES_TOOL_RUN_WHITELISTED_QUERY]: "Running saved query",
	[POSTGRES_TOOL_PROPOSE_QUERY]: "Preparing database query",
}

// Connectors used to register one tool per provider under these prefixes. The
// router replaced them, but stored chat history still carries the old names.
export const CUSTOM_DATA_TOOL_PREFIX = "customData_"
export const CUSTOM_DATA_MCP_TOOL_PREFIX = "customMcp_"

export function getToolDisplayName(toolName: string): string | undefined {
	const mapped = TOOL_NAME_MAPPINGS[toolName]
	if (mapped) return mapped
	if (toolName.startsWith(CUSTOM_DATA_TOOL_PREFIX)) {
		return toolName.endsWith("_read")
			? "Checking your account"
			: "Updating your account"
	}
	if (toolName.startsWith(CUSTOM_DATA_MCP_TOOL_PREFIX)) {
		return "Checking a connected system"
	}
	return undefined
}
